import { useState } from 'react';
import {
  SPHERES,
  completedPeriods,
  isSphereId,
  periodReport,
  reportParagraphs,
} from '@superposition/domain';
import { useLoadedState } from '../../lib/store.js';
import { useSphereName } from '../../lib/names.js';
import { useLakePractices, useLocale } from '../../lib/profile.js';
import { matrixColor } from '../../lib/palette.js';
import { useT } from '../../i18n/index.js';

/** отчеты за прошедшие месяцы ведения матрицы: весь период, последний сверху */
export function Reports(): React.ReactNode {
  const { state, store } = useLoadedState();
  const sphereName = useSphereName();
  const t = useT();
  const locale = useLocale();
  const practices = useLakePractices();
  const n = completedPeriods(state, store.today);
  const [open, setOpen] = useState<number | null>(n || null);
  if (n < 1) return null;

  const lake = (practices ?? []).map((p) => p.sphere).filter(isSphereId);
  return (
    <div className="reports">
      <h4>{t.reports.title}</h4>
      {Array.from({ length: n }, (_, i) => n - i).map((k) => {
        const r = periodReport(state, k);
        if (!r) return null;
        const on = open === k;
        return (
          <div key={k} className={`report${on ? ' on' : ''}`}>
            <button type="button" className="report-h" aria-expanded={on} onClick={() => setOpen(on ? null : k)}>
              <b>{t.reports.month({ n: k })}</b>
              <span>{t.reports.period({ from: r.from, to: r.to, filled: r.filled, days: r.days })}</span>
            </button>
            {on ? (
              <div className="report-b">
                <table className="report-t">
                  <thead>
                    <tr>
                      <th>{t.reports.colSphere}</th>
                      <th>{t.reports.colSkills}</th>
                      <th>{t.reports.colValue}</th>
                      <th>{t.reports.colVerdict}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {r.spheres.map((s) => (
                      <tr key={s.id} className={`v-${s.verdict}`}>
                        <td>
                          <span className="dot" style={{ background: matrixColor(s.id).c }} />
                          {sphereName(s.id)}
                        </td>
                        <td>{s.skills ? `${Math.round(s.activity * 100)}%` : '—'}</td>
                        <td>{s.valueFrom !== null && s.valueTo !== null ? `${s.valueFrom} → ${s.valueTo}` : '—'}</td>
                        <td>{t.reports.verdict[s.verdict]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {reportParagraphs(r, sphereName, lake, locale).map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
      <p className="report-note">
        {t.reports.note({ spheres: SPHERES.length })}
      </p>
    </div>
  );
}
